<template>
  <v-card outlined>
    <v-card-title>
      {{ $t('admin_panel.radars.title')|toUppercase }}
    </v-card-title>
    <v-card-text>
      <v-data-table
          :headers="headers"
          :items="radars"
          item-key="id"
          hide-default-footer
          @click:row="openRadar"
      >
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at|formatDate }}
        </template>

        <template v-slot:item.is_private="{ item }">
          <v-simple-checkbox
              :value="!item.is_private"
              disabled
          ></v-simple-checkbox>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RadarList',
  computed: {
    ...mapGetters({
      radars: 'admin/radars'
    })
  },
  data () {
    return {
      headers: [
        { text: this.$t('admin_panel.radars.created_at') , value: 'created_at', sortable: true},
        { text: this.$t('admin_panel.radars.name'), value: 'name', sortable: true},
        { text: this.$t('admin_panel.radars.is_public'), value: 'is_private', sortable: true},
        { text: this.$t('admin_panel.radars.user'), value: 'owner_name', sortable: true},
      ]
    }
  },
  mounted () {
    this.$store.dispatch('admin/loadRadars');
  },
  methods: {
    /**
     * @click:row="openRadar"
     * @param radar
     */
    openRadar(radar) {
      this.$router.push({ name: 'radar', params: { radarId: radar.id } }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
